import IconButton from "../../components/button/IconButton";
import * as React from "react";
import {ButtonGroup} from "react-bootstrap";
import { useModels } from "../../helpers/models";
import ConfirmIconButton from "../../components/button/ConfirmIconButton";
import Table from "../../components/table/Table";
import columns from "./ProductionHistoryTableConfig";
import { useTranslation } from 'react-i18next';

export function ProductionTableActions(props) {

    const { t } = useTranslation();
    const buttonSize = "md"
    const models = useModels();


    return <div className={"d-flex"}>
        <ButtonGroup>

            <IconButton
                variant={"outline-primary"}
                // className="btn-circle ml-1"
                onClick={() => props.history.push("/production/" + props.row.id)}
                size={buttonSize}
                tooltip={t("menu.production")}
                icon={models.production.icon}
            />
            <ConfirmIconButton
                confirmTitle={t("production.production_history")}
                size={"md"}
                print
                tooltip={t("production.production_history")}
                variant={"outline-primary"}
                icon={"fa-clock-rotate-left"}
                modalSize={"xl"}
                alert={true}
                modelChildren={
                    <Table
                        source={"/production/history/" + props.row.id}
                        setLoader={props.setLoader}
                        columns={columns(t)}
                        searchConf={[
                            {
                                field: "productionStartDate",
                                fieldType: "date",
                                searchType: "range"
                            }
                        ]}
                    />
                }

            />
        </ButtonGroup>

    </div>;
}